import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import axios from "axios";
import { Logo } from "@/components/Brand";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { API, errMsg, SUPPORT_TEL } from "@/lib/api";

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) return toast.error("Şifreler eşleşmiyor");
    setBusy(true);
    try {
      await axios.post(`${API}/auth/reset-password`, { token, password: pw });
      setDone(true);
      setTimeout(() => navigate("/sign-in"), 2500);
    } catch (err) {
      toast.error(errMsg(err));
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-6 bg-slate-50" data-testid="reset-password-page">
      <Link to="/" className="mb-6"><Logo className="h-14 w-14" /></Link>
      <form onSubmit={submit} className="w-full max-w-sm rounded-3xl border border-[#0F1F45]/10 bg-white p-8 shadow-xl space-y-4" data-testid="reset-form">
        <h2 className="font-display text-xl font-bold text-[#0F1F45]">Yeni Şifre Belirleyin</h2>
        {done ? (
          <p className="text-sm text-emerald-700 bg-emerald-50 rounded-xl p-3" data-testid="reset-success">Şifreniz güncellendi. Giriş sayfasına yönlendiriliyorsunuz...</p>
        ) : !token ? (
          <p className="text-sm text-amber-700 bg-amber-50 rounded-xl p-3" data-testid="reset-no-token">Bağlantı geçersiz. Lütfen e-postanızdaki bağlantıyı kullanın veya yeni bir sıfırlama talebi oluşturun.</p>
        ) : (
          <>
            <div><Label>Yeni şifre (en az 6 karakter)</Label><Input type="password" required minLength={6} value={pw} onChange={(e) => setPw(e.target.value)} data-testid="reset-password-input" /></div>
            <div><Label>Yeni şifre (tekrar)</Label><Input type="password" required minLength={6} value={pw2} onChange={(e) => setPw2(e.target.value)} data-testid="reset-password2-input" /></div>
            <Button disabled={busy} className="w-full rounded-full bg-[#FF6B0A] hover:bg-[#E55A00]" data-testid="reset-submit-btn">{busy ? "Kaydediliyor..." : "Şifremi Güncelle"}</Button>
          </>
        )}
        <p className="text-xs text-slate-500 bg-slate-50 border rounded-xl p-3" data-testid="pw-support-note">
          Sorun yaşarsanız bize <a href={SUPPORT_TEL} className="font-semibold text-[#FF6B0A]">0542 396 12 60</a> numarası üzerinden ulaşabilirsiniz.
        </p>
        <Link to="/sign-in" className="block text-center text-sm font-semibold text-[#FF6B0A]" data-testid="reset-back-login">← Girişe dön</Link>
      </form>
    </div>
  );
}
